import styled, { css } from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 57vw;
  margin-top: 2.8vh;
  margin-left: 1.5vw;
  margin-right: 1vw;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const SubText = styled.p`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin-left: 1.5vw;
`

export const ListItem = styled.li`
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 400;
  margin-top: 0;
  margin-bottom: 0;
`

export const SuccessText = styled.span`
  color: green;
`

// Estilos para a palavra "ERRO"
export const ErrorText = styled.span`
  color: red;
`

export const ProgressContainer = styled.div`
  height: 18px;
  background-color: grey;
  margin-top: 3vh;
  margin-bottom: 3vh;
  margin-left: 1.2vw;
  left: 36px;
  width: 780px;
  border-radius: 2vw;

  //   @media (min-width: 1600px) {
  //     left: 36px;
  //     width: 280px;
  //   }

  //   @media (max-width: 1600px) {
  //     left: 36px;
  //     width: 229px;
  //   }

  //   @media (max-width: 1366px) {
  //     left: 36px;
  //     width: 184px;
  //   }

  //   @media (max-width: 1200px) {
  //     left: 30px;
  //     width: 140px;
  //   }
`

export const ProgressFill = styled.div`
  height: 18px;
  background-color: #6ec1e4;
  border-radius: 2vw;
`

export const ButtonsDiv = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin-left: 49.5vw;
`

export const FinishButton = styled.button`
  width: 8vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 2.5vh;
  border: 1px #0090d3 solid;
  border-radius: 3vw;
  cursor: pointer;
`

export const DisabledFinishButton = styled.button`
  width: 8vw;
  height: 5.8vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-bottom: 2.5vh;
  border: 0;
  border-radius: 3vw;
  cursor: not-allowed;
`
